import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CoreHttpActions, CoreHttpActionsType } from './core-http.actions';
import { CoreHttpError } from './core-http.models';

export interface CoreHttpState {
  error: CoreHttpError;
  pending: boolean;
  pendingQueue: number;
  internetConnection: boolean;
  httpResponseMessage: string;
  maintenanceModeMessage: string;
}

export const coreHttpInitialState: CoreHttpState = {
  error: void 0,
  pending: false,
  pendingQueue: 0,
  internetConnection: void 0,
  httpResponseMessage: void 0,
  maintenanceModeMessage: void 0
};

export function coreHttpReducer(
  state = coreHttpInitialState,
  action: CoreHttpActions
) {
  switch (action.type) {
    case CoreHttpActionsType.SET_ERROR:
      return { ...state, error: action.payload };

    case CoreHttpActionsType.SET_PENDING:
      return { ...state, pending: action.payload };

    case CoreHttpActionsType.INCREMENT_PENDING_QUEUE:
      return { ...state, pendingQueue: state.pendingQueue + action.payload };

    case CoreHttpActionsType.DECREMENT_PENDING_QUEUE:
      return { ...state, pendingQueue: state.pendingQueue - action.payload };

    case CoreHttpActionsType.INTERNET_IS_WORKING:
      return { ...state, internetConnection: action.payload };

    case CoreHttpActionsType.INTERNET_NOT_WORKING:
      return { ...state, internetConnection: action.payload };

    case CoreHttpActionsType.SET_HTTP_RESPONSE_MESSAGE:
      return { ...state, httpResponseMessage: action.payload };

    case CoreHttpActionsType.SET_MAINTENANCE_MODE:
      return { ...state, maintenanceModeMessage: action.payload };

    default:
      return state;
  }
}

const featureSelector = createFeatureSelector<CoreHttpState>('http');

export const selectorCoreHttpError = createSelector(
  featureSelector,
  state => state.error
);

export const selectorCoreHttpPending = createSelector(
  featureSelector,
  state => state.pending
);

export const selectorCoreHttpPendingQueue = createSelector(
  featureSelector,
  state => state.pendingQueue
);

export const selectorCoreHttpInternetConnection = createSelector(
  featureSelector,
  state => state.internetConnection
);

export const selectorCoreHttpResponseMessage = createSelector(
  featureSelector,
  state => state.httpResponseMessage
);

export const selectorCoreHttpMaintenanceModeMessage = createSelector(
  featureSelector,
  state => state.maintenanceModeMessage
);
